import {
  AdditionalCover,
  Payment,
  PaymentB,
  PersonalDetails,
  PersonalDetailsB,
  SchemeChoice,
  SchemeChoiceB,
  TripDetails,
  Declaration,
  DeclarationB,
  Complete,
  TripDetailsJourneyB,
} from './scenes';
import { IChannel, IStep } from '../../data/api/models';
import { Component } from 'react';
import { stepsCustom } from './stepsCustom';

export interface IReactStep extends IStep {
  component: Component;
}

const componentKeyMap = {
  tripDetails: TripDetails,
  declaration: Declaration,
  declarationB: DeclarationB,
  schemeChoice: SchemeChoice,
  additionalCover: AdditionalCover,
  personalDetails: PersonalDetails,
  payment: Payment,
  complete: Complete,
};

const journeyBComponentKeyMap = {
  tripDetails: TripDetailsJourneyB,
  declaration: DeclarationB,
  schemeChoice: SchemeChoiceB,
  additionalCover: AdditionalCover,
  personalDetails: PersonalDetailsB,
  payment: PaymentB,
  complete: Complete,
};

function mapComponentsFromKey(step: IStep, channel?: IChannel): IReactStep {
  if (channel && channel.key === 'csis-b2c'
      || channel && channel.key === 'tpl-b2c'
      || channel && channel.key === 'camc-b2c') {
    return {
      ...step,
      component: journeyBComponentKeyMap[step.key],
    };
  }
  return {
    ...step,
    component: componentKeyMap[step.key],
  };
}

export default (channel?: IChannel): IReactStep[] => {

  const navTitle = ['Trip Details', 'Declaration', 'Cover Choice', 'Personal Details', 'Payment', 'Complete'];

  const defaultSteps: IStep[] = [
    {
      title: navTitle[0],
      key: 'tripDetails',
      route: '/trip-details',
      calculatePremium: false,
      saveApplication: true,
      saveApplicationWithPatch: false,
    },
    {
      title: navTitle[1],
      key: 'declaration',
      route: '/declaration',
      calculatePremium: false,
      saveApplication: true,
      saveApplicationWithPatch: false,
    },
    {
      title: navTitle[2],
      key: 'schemeChoice',
      route: '/scheme-choice',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
    },
    {
      title: navTitle[3],
      key: 'personalDetails',
      route: '/personal-details',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
    },
    {
      title: navTitle[4],
      key: 'payment',
      route: '/payment',
      calculatePremium: false,
      saveApplication: true,
      saveApplicationWithPatch: false,
    },
    {
      title: navTitle[5],
      key: 'complete',
      route: '/complete',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      hidden: true,
    },
  ];

  const customSteps = stepsCustom[channel.key];
  const config = customSteps ? customSteps : defaultSteps;

  return config.map((step) => mapComponentsFromKey(step, channel));
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/steps.tsx